<div
  *ngIf="
    !isPass &&
    inputVal.invalid &&
    inputVal.errors &&
    (inputVal.dirty || inputVal.touched)
  "
  class="text-left">
  <p
    *ngIf="inputVal.hasError('required')"
    class="color-psr-danger f11 py-4 my-0">
    {{ 'alerts.ERRORS.REQUIRED' | translate }}
  </p>
  <p
    *ngIf="inputVal.hasError('minlength')"
    class="color-psr-danger f11 py-4 my-0">
    {{ 'alerts.ERRORS.MINLENGTH' | translate }}
    {{ inputVal.errors.minlength.requiredLength }}
    {{ 'alerts.ERRORS.CHARS' | translate }}.
  </p>
  <p
    *ngIf="inputVal.hasError('maxlength')"
    class="color-psr-danger f11 py-4 my-0">
    {{ 'alerts.ERRORS.MAXLENGTH' | translate }}
    {{ inputVal.errors.maxlength.requiredLength }}
    {{ 'alerts.ERRORS.CHARS' | translate }}.
  </p>
  <p *ngIf="inputVal.hasError('min')" class="color-psr-danger f11 py-4 my-0">
    {{ 'alerts.ERRORS.MIN' | translate }} {{ inputVal.errors.min.min }}.
  </p>
  <p *ngIf="inputVal.hasError('max')" class="color-psr-danger f11 py-4 my-0">
    {{ 'alerts.ERRORS.MAX' | translate }} {{ inputVal.errors.max.max }}.
  </p>
  <p
    *ngIf="
      !inputVal.hasError('minlength') &&
      !inputVal.hasError('maxlength') &&
      inputVal.hasError('pattern')
    "
    class="color-psr-danger f11 py-4 my-0">
    {{ 'alerts.ERRORS.INVALID_FORMAT' | translate }}.
  </p>
</div>

<div
  *ngIf="
    isPass &&
    inputVal.invalid &&
    inputVal.errors &&
    (inputVal.dirty || inputVal.touched)
  "
  class="text-left">
  <p
    *ngIf="inputVal.hasError('required')"
    class="color-psr-danger f11 py-4 my-0">
    {{ 'alerts.ERRORS.REQUIRED' | translate }}
  </p>

  <p
    *ngIf="
      inputVal.hasError('hasCapitalCase') ||
      inputVal.hasError('hasSmallCase') ||
      inputVal.hasError('hasNumber')
    "
    class="color-psr-danger f11 py-4 my-0">
    {{ 'alerts.ERRORS.PASSWORD_VALID' | translate }}
  </p>

  <p
    *ngIf="
      inputVal.hasError('minlength') &&
      !(
        inputVal.hasError('hasCapitalCase') ||
        inputVal.hasError('hasSmallCase') ||
        inputVal.hasError('hasNumber')
      )
    "
    class="color-psr-danger f11 py-4 my-0">
    {{ 'alerts.ERRORS.PASSWORD_MINLENGTH' | translate }}
  </p>

  <p
    *ngIf="
      inputVal.hasError('maxlength') &&
      !(
        inputVal.hasError('hasCapitalCase') ||
        inputVal.hasError('hasSmallCase') ||
        inputVal.hasError('hasNumber')
      )
    "
    class="color-psr-danger f11 py-4 my-0">
    {{ 'alerts.ERRORS.MAXLENGTH' | translate }}
    {{ inputVal.errors.maxlength.requiredLength }}
    {{ 'ERRORS.CHARS' | translate }}.
  </p>

  <p
    *ngIf="inputVal.hasError('confirmedValidator')"
    class="color-psr-danger f11 py-4 my-0">
    {{ 'alerts.ERRORS.ERROR_CONFIRMPASSWORD' | translate }}
  </p>
</div>
